import * as React from 'react';

const DataMgr = React.lazy(() => import('./container'));

export default () => <DataMgr />;
